import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./policyDetails.scss";
import { format } from "date-fns";
import { getHealthPolicyStatus, getPolicyMembers, POLICY_STATUSES } from "../ClaimForm/helper";

const renderDetailList = (details, highlightKey = "", customLabels = {}) => {
  const formatLabel = (key) => {
    if (customLabels[key]) return customLabels[key];
    if (key === key.toUpperCase()) return key; // Keep abbreviations like GST, CGST
    if (key === "PolicyID") return "Policy ID"; // Special case
    return key
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter
  };

  return (
    <ul className="list-unstyled">
      {Object.entries(details).map(([key, value]) => (
        <li
          key={key}
          className={`detail-item ${key === highlightKey ? "highlight-total" : ""
            }`}
        >
          <span className="label">{formatLabel(key)}:</span>
          <span className="value">{value}</span>
        </li>
      ))}
    </ul>
  );
};

const PolicyDetails = ({ policyData }) => {
  try {
    const generalDetails = {
      policyId: policyData?.policy_no || "-",
      insuredMembers:
        getPolicyMembers(policyData)?.length || "--",
      tenure: policyData?.tenure || "--",
      startDate: policyData?.policy_start_date
        ? format(new Date(policyData.policy_start_date), "dd-MM-yyyy")
        : "--",
      endDate: policyData?.policy_end_date
        ? format(new Date(policyData.policy_end_date), "dd-MM-yyyy")
        : "--",
    };
    const riderDetails = {
      "premium (₹)": policyData?.base_premium || "--",
      ...(policyData?.igst
        ? { "IGST (₹)": policyData.igst }
        : {
          "SGST (₹)": policyData?.sgst || "--",
          "CGST (₹)": policyData?.cgst || "--",
        }),
      "Total Premium (₹)": policyData?.total_premium || "--",
    };
    const nomineeDetails = {
      name: policyData?.nominee_name || "--",
      relationship: policyData?.nominee_relation || "--",
    };
    return (
      <Container fluid className="policy-container">
        <Card className="custom-card">
          <div className="d-flex justify-content-between me-2">
            <h2 className="section-title">Policy Details</h2>
            <span>
              <span className="pe-2">
                Status:
              </span>
              {getHealthPolicyStatus(policyData?.policy_status) ? (
                <span className={getHealthPolicyStatus(policyData?.policy_status) === POLICY_STATUSES.ACTIVE ? "label label-success" : "label label-danger"}>
                  {" "}{getHealthPolicyStatus(policyData?.policy_status)}
                </span>
              )
                : " -- "}
            </span>
          </div>

          <Row xs={1} md={2} lg={3} className="g-4">
            <Col>
              <Card.Body>
                <Card.Title>General Details</Card.Title>
                {renderDetailList(generalDetails)}
              </Card.Body>
            </Col>
            <Col>
              <Card.Body>
                <Card.Title>Premium Details</Card.Title>
                {renderDetailList(riderDetails, "total")}
              </Card.Body>
            </Col>
            <Col>
              <Card.Body>
                <Card.Title>Nominee Details</Card.Title>
                {renderDetailList(nomineeDetails)}
              </Card.Body>
            </Col>
          </Row>
        </Card>
      </Container>
    );
  } catch (error) {
    console.error("Error rendering PolicyDetails:", error);
    return "Policy Details Unavailable";
  }
};

export default PolicyDetails;
